import React from 'react';
import { useDispatch } from 'react-redux';
import ListItem from '@material-ui/core/ListItem';
import { selectEntity } from 'actions/map';
import { MapEntityInfo } from 'UI/components/molecules/MapEntityInfo';
import { MapEntityStatus } from 'UI/components/molecules/MapEntityStatus';

import { getInventoryDetailsLabel } from './MapInventoryItem.utils';

/**
 * @typedef {Object} EntityItemProps
 * @property {string} title
 * @property {string} subtitle
 * @property {string} description
 * @property {string} [detailsLabel]
 * @property {string} type
 * @property {string} color
 */

/**
 * @param {Object} props
 * @param {EntityItemProps} props.entityProps
 * @param {*} props.info
 * @param {string} props.entity
 */
const MapInventoryItem = ({ info, entity, entityProps }) => {
  const dispatch = useDispatch();

  const { description, detailsLabel: entityDetailsLabel, title, subtitle, type } = entityProps;

  const handleClick = () => {
    dispatch(selectEntity(info));
  };

  const markerType = info.type_detail?.id;

  const detailsLabel = entityDetailsLabel || getInventoryDetailsLabel({ entity });

  return (
    <ListItem onClick={handleClick} button divider>
      <MapEntityInfo
        details={description}
        detailsLabel={detailsLabel}
        entityStatus={<MapEntityStatus markerType={markerType} entity={entity} type={type} />}
        entitySubtitle={subtitle}
        entityTitle={title}
      />
    </ListItem>
  );
};

export default MapInventoryItem;
